<div class="content">
  <ion-accordion-group class="accordion" (ionChange)="markAsToggled($event)" #accordionGroup>
    <ion-accordion value="item">
      <ion-item lines="full" color="{{ color() }}" slot="header">
        @if (icon()) {
          <ion-icon size="small" slot="start" name="{{ icon() }}" color="{{ colorLeftIcon() }}"></ion-icon>
        }
        <ion-label class="font-label" [style.font-size]="sizeTitle()" color="{{ colorTitle() }}">
          {{ title() }}
        </ion-label>
        <ion-icon
          size="small"
          color="{{ colorIcon() }}"
          class="ion-accordion-toggle-icon icon"
          name="caret-down-outline"
          slot="end"
        ></ion-icon>
      </ion-item>
      <div slot="content">
        <ng-content></ng-content>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</div>
